import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import U2000BasicDialog from '../../../../../u2000Core/components/dialog/U2000BasicDialog';
import { NS } from '../../../../U3121';

export interface U3121ProjectDocumentPreviewExpandDialogProps {
  isOpen: boolean;
  onClose: () => void;
  pdfObjectUrl: string;
  fileName: string | null;
}

const U3121ProjectDocumentPreviewExpandDialog: React.FC<
  U3121ProjectDocumentPreviewExpandDialogProps
> = ({ isOpen, onClose, pdfObjectUrl, fileName }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  return (
    <U2000BasicDialog
      isOpen={isOpen}
      onClose={() => onClose()}
      onBackdropClick={() => onClose()}
      title={fileName ?? t('lblDocumentPreview', { ns: NS })}
      width="w-[min(99vw,2560px)] max-w-[min(99vw,2560px)]"
      height="h-[min(98vh,1600px)] max-h-[98vh]"
      style={{
        maxWidth: 'min(99vw, 2560px)',
        width: 'min(99vw, 2560px)',
        height: 'min(98vh, 1600px)',
      }}
      /* Chaîne flex sur <main> (sinon iframe reste en bandeau bas, comme U3140). */
      contentOverflowVisible
      overlayClassName="z-50 p-2"
    >
      <div className="relative min-h-0 w-full flex-1">
        <iframe
          title={fileName ?? t('lblDocumentPreview', { ns: NS })}
          src={pdfObjectUrl}
          className="absolute inset-0 h-full w-full border-0 bg-gray-50"
        />
      </div>
    </U2000BasicDialog>
  );
};

export default U3121ProjectDocumentPreviewExpandDialog;
